


































import { Component, Vue } from 'vue-property-decorator'
import { Helper } from '@/helpers/Helper'
import PageHead from '@/components/PageHead.vue'
import { Notify } from '@/helpers/Notify'
import { Api } from '@/fetch/Api'
import type { SecondaryDomain } from '@/interfaces'
import store from '@/store'
import moment from 'moment'

@Component({
  components: {
    PageHead,
  },
})

export default class SnapshotList extends Vue {
  pageTitle = 'Secondary Domains'
  callInProgress = false
  secondaryDomainsList: SecondaryDomain[] = null
  secondaryDomain = null

  get Helper() {
    return Helper
  }

  mounted() {
    this.fetchSecondaryDomainsList()
  }

  public async fetchSecondaryDomainsList() {
    this.callInProgress = true
    try {
      const secondaryDomainsListResponse = await Api.fetchSecondaryDomainsList()
      this.secondaryDomainsList = secondaryDomainsListResponse.secondaryDomainsList
      this.callInProgress = false
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public comfirmDelete(secondaryDomain) {
    const h = this.$createElement
    this.$bvModal.msgBoxConfirm([h('span', { domProps: { innerHTML: 'Are you sure you want to delete the secondary domain ? It will no more redirect the user to respective primary domain!' } })], {
      title: [h('span', { domProps: { innerHTML: '<b>Delete Confirmation!</b>' } })],
      size: 'md',
      buttonSize: 'sm',
      okVariant: 'success',
      cancelVariant: 'danger',
      okTitle: 'Proceed',
      cancelTitle: 'Cancel',
      footerClass: 'p-2',
      hideHeaderClose: false,
      centered: true,
    }).then(value => {
      if (value) {
        this.deleteSecondaryDomain(secondaryDomain)
      }
    }).catch(err => {
      alert(err)
    })
  }

  public async deleteSecondaryDomain(secondaryDomain) {
    this.callInProgress = true
    try {
      await Api.deleteSecondaryDomain(secondaryDomain)
      this.callInProgress = false
      store.commit('toggleFlag')
      this.fetchSecondaryDomainsList()
      Notify.create({
        type: 'success',
        title: 'Deleted!',
        text: 'Intended secondary domain deleted!',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }

  public async addSecondaryDomain() {
    this.callInProgress = true
    try {
      await Api.addSecondaryDomain(this.secondaryDomain)
      this.secondaryDomain = null
      this.callInProgress = false
      store.commit('toggleFlag')
      this.fetchSecondaryDomainsList()
      Notify.create({
        type: 'success',
        title: 'Success!',
        text: 'Secondary domain added!',
      })
    } catch (e) {
      this.callInProgress = false
      Notify.create({
        type: 'error',
        title: 'Something went wrong...',
        text: e,
      })
    }
  }
}
